<template>
    <div class="script-square" id="read">
        <div>
            <div class="head">
                <img src="../../assets/img/template-bg.jpg" alt="">
                <div style="width:600px;display:inline-block;height:98px;position:absolute;left:50%;top:50%;margin-left:-300px;margin-top:-49px;">
                    <div style="color:#fff;font-size:28px;font-weight:bold">海量模板供您选择</div>
                    <a-input v-model="keyword" @keyup.enter="enterSearchMember" placeholder="您可以搜索模板名称、简介、开场白、台词" type="text" style="display:inline-block;width:600px;height:42px;border-radius:8px;border:none;margin-top:16px;">
                        <a-icon style="color:rgba(153, 153, 153, 1)" slot="prefix" type="search" />
                    </a-input>
                </div>
            </div>
            <div class="tutorials">
                <div style="width:1200px;margin:0 auto;">
                    <div style="color:rgba(51, 51, 51, 1);font-size:18px;font-weight:bold;padding:20px 0 14px 0;">精选教程</div>
                    <a-carousel arrows :dots='false' :autoplay='true'>
                        <div slot="prevArrow" class="custom-slick-arrow" style="left: 10px;zIndex: 1" >
                            <a-icon type="left-circle" />
                        </div>
                        <div slot="nextArrow" class="custom-slick-arrow" style="right: 10px">
                            <a-icon type="right-circle" />
                        </div>
                        <div class="carousel-pic" v-for="(item, index) in picData" :key="index">
                            <img @click="jumpToLink(item1.url)" v-for="(item1, index1) in item" :key="index1" :src="item1.picture" alt="">
                        </div>
                    </a-carousel>
                </div>
            </div>
            <div class="content">
                <div style="width:1200px;margin:0 auto;display:flex;">
                    <div class="left-menu" :class="{'place1':placeActive==true}">
                        <div :class="{'active':currentChannel==item.value}" @click="selectChannel(item)" v-for="(item, index) in channelList" :key="index">
                            <a-icon type="solution" />
                            <span>{{item.name}}</span>
                        </div>
                    </div>
                    <div class="right-content">
                        <div :class="{'place2':placeActive==true}">
                            <div class="tag-list">
                                <span :class="{'active':currentTag==''}" @click="selectTag('')">全部</span>
                                <span :class="{'active':currentTag==item.id}" @click="selectTag(item.id)" v-for="(item, index) in sceneList" :key="index">{{item.name}}</span>
                            </div>
                            <div class="choose-type">
                                <span @click="chooseTab('EXPERIENCECOUNT')" :class="{'active':currentTab=='EXPERIENCECOUNT'}">体验量最多</span>
                                <span @click="chooseTab('DOWNLOADCOUNT')" :class="{'active':currentTab=='DOWNLOADCOUNT'}">下载量最多</span>
                            </div>
                        </div>
                        <div class="project-list" :class="{'place3':placeActive==true}">
                            <div class="col">
                                <div class="list" v-for="(item,index) in dataList1" :key='index'>
                                    <div class="box1">
                                        <div class="mask">
                                            <div @click="experiencePro(item)">体验</div>
                                            <div @click="copyPro(item.id)">克隆</div>
                                        </div>
                                        <div class="generalization">
                                            <div class="item">
                                                <div class="item-content">
                                                    <img src="../../assets/img/node.svg" alt="">
                                                    <span>节点</span>
                                                </div>
                                                <div class="num">{{item.nodeCount}}</div>
                                            </div>
                                            <div class="item">
                                                <div class="item-content">
                                                    <img src="../../assets/img/intention.svg" alt="">
                                                    <span>意图</span>
                                                </div>
                                                <div class="num">{{item.intentionCount}}</div>
                                            </div>
                                            <div class="item">
                                                <div class="item-content">
                                                    <img src="../../assets/img/sample.svg" alt="">
                                                    <span>样本</span>
                                                </div>
                                                <div class="num">{{item.sampleCount}}</div>
                                            </div>
                                            <div class="item">
                                                <div class="item-content">
                                                    <img src="../../assets/img/script.svg" alt="">
                                                    <span>脚本</span>
                                                </div>
                                                <div class="num">{{item.talkingSkillCount}}</div>
                                            </div>
                                        </div>
                                        <div style="clear:both"></div>
                                        <div class="title">开场白</div>
                                        <div class="des">{{item.openingWords}}</div>
                                        <div class="time">[{{item.createTime}}]</div>
                                        <div style="border-bottom:1px solid rgba(224, 224, 224, 1);margin:7px auto 10px;"></div>
                                    </div>
                                    <div class="box2">
                                        <div class="title2">{{item.name}}</div>
                                        <div class="status">
                                            <img src="../../assets/img/eye.svg" alt="">
                                            <span>{{item.experienceCount}}</span>
                                            <img src="../../assets/img/download.svg" alt="">
                                            <span>{{item.downloadCount}}</span>
                                        </div>
                                        <div class="foot">
                                            <img :src="item.enterpriseAvatar" alt="">
                                            <span>{{nameReplace(item.enterpriseName)}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col">
                                <div class="list" v-for="(item,index) in dataList2" :key='index'>
                                    <div class="box1">
                                        <div class="mask">
                                            <div @click="experiencePro(item)">体验</div>
                                            <div @click="copyPro(item.id)">克隆</div>
                                        </div>
                                        <div class="generalization">
                                            <div class="item">
                                                <div class="item-content">
                                                    <img src="../../assets/img/node.svg" alt="">
                                                    <span>节点</span>
                                                </div>
                                                <div class="num">{{item.nodeCount}}</div>
                                            </div>
                                            <div class="item">
                                                <div class="item-content">
                                                    <img src="../../assets/img/intention.svg" alt="">
                                                    <span>意图</span>
                                                </div>
                                                <div class="num">{{item.intentionCount}}</div>
                                            </div>
                                            <div class="item">
                                                <div class="item-content">
                                                    <img src="../../assets/img/sample.svg" alt="">
                                                    <span>样本</span>
                                                </div>
                                                <div class="num">{{item.sampleCount}}</div>
                                            </div>
                                            <div class="item">
                                                <div class="item-content">
                                                    <img src="../../assets/img/script.svg" alt="">
                                                    <span>脚本</span>
                                                </div>
                                                <div class="num">{{item.talkingSkillCount}}</div>
                                            </div>
                                        </div>
                                        <div style="clear:both"></div>
                                        <div class="title">开场白</div>
                                        <div class="des">{{item.openingWords}}</div>
                                        <div class="time">[{{item.createTime}}]</div>
                                        <div style="border-bottom:1px solid rgba(224, 224, 224, 1);margin:7px auto 10px;"></div>
                                    </div>
                                    <div class="box2">
                                        <div class="title2">{{item.name}}</div>
                                        <div class="status">
                                            <img src="../../assets/img/eye.svg" alt="">
                                            <span>{{item.experienceCount}}</span>
                                            <img src="../../assets/img/download.svg" alt="">
                                            <span>{{item.downloadCount}}</span>
                                        </div>
                                        <div class="foot">
                                            <img :src="item.enterpriseAvatar" alt="">
                                            <span>{{nameReplace(item.enterpriseName)}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col">
                                <div class="list" v-for="(item,index) in dataList3" :key='index'>
                                    <div class="box1">
                                        <div class="mask">
                                            <div @click="experiencePro(item)">体验</div>
                                            <div @click="copyPro(item.id)">克隆</div>
                                        </div>
                                        <div class="generalization">
                                            <div class="item">
                                                <div class="item-content">
                                                    <img src="../../assets/img/node.svg" alt="">
                                                    <span>节点</span>
                                                </div>
                                                <div class="num">{{item.nodeCount}}</div>
                                            </div>
                                            <div class="item">
                                                <div class="item-content">
                                                    <img src="../../assets/img/intention.svg" alt="">
                                                    <span>意图</span>
                                                </div>
                                                <div class="num">{{item.intentionCount}}</div>
                                            </div>
                                            <div class="item">
                                                <div class="item-content">
                                                    <img src="../../assets/img/sample.svg" alt="">
                                                    <span>样本</span>
                                                </div>
                                                <div class="num">{{item.sampleCount}}</div>
                                            </div>
                                            <div class="item">
                                                <div class="item-content">
                                                    <img src="../../assets/img/script.svg" alt="">
                                                    <span>脚本</span>
                                                </div>
                                                <div class="num">{{item.talkingSkillCount}}</div>
                                            </div>
                                        </div>
                                        <div style="clear:both"></div>
                                        <div class="title">开场白</div>
                                        <div class="des">{{item.openingWords}}</div>
                                        <div class="time">[{{item.createTime}}]</div>
                                        <div style="border-bottom:1px solid rgba(224, 224, 224, 1);margin:7px auto 10px;"></div>
                                    </div>
                                    <div class="box2">
                                        <div class="title2">{{item.name}}</div>
                                        <div class="status">
                                            <img src="../../assets/img/eye.svg" alt="">
                                            <span>{{item.experienceCount}}</span>
                                            <img src="../../assets/img/download.svg" alt="">
                                            <span>{{item.downloadCount}}</span>
                                        </div>
                                        <div class="foot">
                                            <img :src="item.enterpriseAvatar" alt="">
                                            <span>{{nameReplace(item.enterpriseName)}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col">
                                <div class="list" v-for="(item,index) in dataList4" :key='index'>
                                    <div class="box1">
                                        <div class="mask">
                                            <div @click="experiencePro(item)">体验</div>
                                            <div @click="copyPro(item.id)">克隆</div>
                                        </div>
                                        <div class="generalization">
                                            <div class="item">
                                                <div class="item-content">
                                                    <img src="../../assets/img/node.svg" alt="">
                                                    <span>节点</span>
                                                </div>
                                                <div class="num">{{item.nodeCount}}</div>
                                            </div>
                                            <div class="item">
                                                <div class="item-content">
                                                    <img src="../../assets/img/intention.svg" alt="">
                                                    <span>意图</span>
                                                </div>
                                                <div class="num">{{item.intentionCount}}</div>
                                            </div>
                                            <div class="item">
                                                <div class="item-content">
                                                    <img src="../../assets/img/sample.svg" alt="">
                                                    <span>样本</span>
                                                </div>
                                                <div class="num">{{item.sampleCount}}</div>
                                            </div>
                                            <div class="item">
                                                <div class="item-content">
                                                    <img src="../../assets/img/script.svg" alt="">
                                                    <span>脚本</span>
                                                </div>
                                                <div class="num">{{item.talkingSkillCount}}</div>
                                            </div>
                                        </div>
                                        <div style="clear:both"></div>
                                        <div class="title">开场白</div>
                                        <div class="des">{{item.openingWords}}</div>
                                        <div class="time">[{{item.createTime}}]</div>
                                        <div style="border-bottom:1px solid rgba(224, 224, 224, 1);margin:7px auto 10px;"></div>
                                    </div>
                                    <div class="box2">
                                        <div class="title2">{{item.name}}</div>
                                        <div class="status">
                                            <img src="../../assets/img/eye.svg" alt="">
                                            <span>{{item.experienceCount}}</span>
                                            <img src="../../assets/img/download.svg" alt="">
                                            <span>{{item.downloadCount}}</span>
                                        </div>
                                        <div class="foot">
                                            <img :src="item.enterpriseAvatar" alt="">
                                            <span>{{nameReplace(item.enterpriseName)}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col">
                                <div class="list" v-for="(item,index) in dataList5" :key='index'>
                                    <div class="box1">
                                        <div class="mask">
                                            <div @click="experiencePro(item)">体验</div>
                                            <div @click="copyPro(item.id)">克隆</div>
                                        </div>
                                        <div class="generalization">
                                            <div class="item">
                                                <div class="item-content">
                                                    <img src="../../assets/img/node.svg" alt="">
                                                    <span>节点</span>
                                                </div>
                                                <div class="num">{{item.nodeCount}}</div>
                                            </div>
                                            <div class="item">
                                                <div class="item-content">
                                                    <img src="../../assets/img/intention.svg" alt="">
                                                    <span>意图</span>
                                                </div>
                                                <div class="num">{{item.intentionCount}}</div>
                                            </div>
                                            <div class="item">
                                                <div class="item-content">
                                                    <img src="../../assets/img/sample.svg" alt="">
                                                    <span>样本</span>
                                                </div>
                                                <div class="num">{{item.sampleCount}}</div>
                                            </div>
                                            <div class="item">
                                                <div class="item-content">
                                                    <img src="../../assets/img/script.svg" alt="">
                                                    <span>脚本</span>
                                                </div>
                                                <div class="num">{{item.talkingSkillCount}}</div>
                                            </div>
                                        </div>
                                        <div style="clear:both"></div>
                                        <div class="title">开场白</div>
                                        <div class="des">{{item.openingWords}}</div>
                                        <div class="time">[{{item.createTime}}]</div>
                                        <div style="border-bottom:1px solid rgba(224, 224, 224, 1);margin:7px auto 10px;"></div>
                                    </div>
                                    <div class="box2">
                                        <div class="title2">{{item.name}}</div>
                                        <div class="status">
                                            <img src="../../assets/img/eye.svg" alt="">
                                            <span>{{item.experienceCount}}</span>
                                            <img src="../../assets/img/download.svg" alt="">
                                            <span>{{item.downloadCount}}</span>
                                        </div>
                                        <div class="foot">
                                            <img :src="item.enterpriseAvatar" alt="">
                                            <span>{{nameReplace(item.enterpriseName)}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div style="text-align:center;" v-if="dataList1.length==0&&dataList2.length==0&&dataList3.length==0&&dataList4.length==0&&dataList5.length==0">
                                <img style="width:140px;margin:60px auto;" src="../../assets/img/none.png" alt="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <a-modal v-model="ifShowTip" title="提示" footer='' :maskClosable='false'>
            <div style="padding:0 16px;text-align:center">
                <img style="margin:0 auto;width:64px;" src="../../assets/img/right.jpg" alt="">
                <div style="font-size:16px;margin-top:24px;color:rgba(51, 51, 51, 1)">克隆成功</div>
                <div style="margin:8px 0px;font-size:16px;text-align:center;color:rgba(36, 38, 48, 1)">
                    您可前往
                    <span @click="goTaskList" style="margin:0 8px;cursor:pointer;color:rgba(34, 215, 187, 1)">我的项目</span>
                    查看详情
                </div>
            </div>
        </a-modal>
    </div>
</template>
<script>
export default {
    name: 'ScriptSquare',
    props: {
        msg: String
    },
    data() {
        return {
            channelList: [
                {
                    name: '全部类型',
                    value: 0
                },
                {
                    name: '智能电话',
                    value: 1
                },
                {
                    name: 'Chatgpt助手',
                    value: 2
                },
                {
                    name: '文字客服',
                    value: 3
                },
                {
                    name: '视频客服',
                    value: 4
                },
                {
                    name: 'H5数字人',
                    value: 5
                },
            ],
            currentChannel: 1,
            currentTab: 'EXPERIENCECOUNT',
            currentTag: '',
            placeActive: false,
            sceneList: [
                {
                    name: '全部',
                    id: '0'
                },
                {
                    name: '第一次',
                    id: '1'
                },
                {
                    name: '第二次',
                    id: '2'
                },
                {
                    name: '第三次',
                    id: '3'
                },
                {
                    name: '第四次',
                    id: '4'
                },
            ],
            proList: [],
            currentPage: 1,
            currentSize: 10,
            dataList1: [],
            dataList2: [],
            dataList3: [],
            dataList4: [],
            dataList5: [],
            heightObj: [0, 0, 0, 0, 0],
            num: 0,
            recordNum: 0,
            ifChangeCondition: false,
            picList: [
                {
                    picture: require('@/assets/img/example.jpg'),
                    url: 'http://www.baidu.com'
                },
                {
                    picture: require('@/assets/img/example.jpg'),
                    url: 'http://www.baidu.com'
                },
                {
                    picture: require('@/assets/img/example.jpg'),
                    url: 'http://www.baidu.com'
                },
                {
                    picture: require('@/assets/img/example.jpg'),
                    url: 'http://www.baidu.com'
                },
                {
                    picture: require('@/assets/img/example.jpg'),
                    url: 'http://www.baidu.com'
                },
                {
                    picture: require('@/assets/img/example.jpg'),
                    url: 'http://www.baidu.com'
                },
                {
                    picture: require('@/assets/img/example.jpg'),
                    url: 'http://www.baidu.com'
                },
                {
                    picture: require('@/assets/img/example.jpg'),
                    url: 'http://www.baidu.com'
                },
                {
                    picture: require('@/assets/img/example.jpg'),
                    url: 'http://www.baidu.com'
                },
                {
                    picture: require('@/assets/img/example.jpg'),
                    url: 'http://www.baidu.com'
                },
                {
                    picture: require('@/assets/img/example.jpg'),
                    url: 'http://www.baidu.com'
                },
                {
                    picture: require('@/assets/img/example.jpg'),
                    url: 'http://www.baidu.com'
                },
                {
                    picture: require('@/assets/img/example.jpg'),
                    url: 'http://www.baidu.com'
                },
                {
                    picture: require('@/assets/img/example.jpg'),
                    url: 'http://www.baidu.com'
                },
                {
                    picture: require('@/assets/img/example.jpg'),
                    url: 'http://www.baidu.com'
                },
                {
                    picture: require('@/assets/img/example.jpg'),
                    url: 'http://www.baidu.com'
                },
                {
                    picture: require('@/assets/img/example.jpg'),
                    url: 'http://www.jd.com'
                },
                {
                    picture: require('@/assets/img/example.jpg'),
                    url: 'http://www.taobao.com'
                },
            ],
            picData: [],
            keyword: '',
            ifShowTip: false,

        }
    },
    methods: {
        selectChannel(item) {
            this.currentChannel = item.value
            console.log(this.proList)
            if(item.value == 1){
                this.currentPage = 1
                this.proList = []
                this.dataList1 = []
                this.dataList2 = []
                this.dataList3 = []
                this.dataList4 = []
                this.dataList5 = []
                this.queryData()
            }else{
                this.currentPage = 1
                this.proList = []
                this.dataList1 = []
                this.dataList2 = []
                this.dataList3 = []
                this.dataList4 = []
                this.dataList5 = []
            }
        },
        chooseTab(param) {
            this.currentTab = param
            this.currentPage = 1
            this.proList = []
            this.dataList1 = []
            this.dataList2 = []
            this.dataList3 = []
            this.dataList4 = []
            this.dataList5 = []
            this.queryData()
            this.ifChangeCondition = true
        },
        selectTag(value) {
            this.currentTag = value
            this.currentPage = 1
            this.proList = []
            this.dataList1 = []
            this.dataList2 = []
            this.dataList3 = []
            this.dataList4 = []
            this.dataList5 = []
            this.queryData()
            this.ifChangeCondition = true
        },
        handleScroll() {
            let scrollTop = document.getElementById("read").scrollTop;
            let offsetHeight = document.getElementById("read").offsetHeight
            let scrollHeight =  document.getElementById("read").scrollHeight
            if (scrollTop > 402) {
                this.placeActive = true
            }else{
                this.placeActive = false
            }
            if(this.ifChangeCondition){
                this.ifChangeCondition = false
            }else{
                if(scrollTop + offsetHeight == scrollHeight){
                    this.currentPage ++
                    this.queryData()
                }
            }
        },
        querySence() {
            this.axios.get('/api/dropdown/scene')
            .then(response=> {
                if(response.data.code == 0){
                    this.sceneList = response.data.data
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        queryData() {
            this.axios(
                {
                    url:'/api/public/project/list', 
                    params:{
                        sceneId: this.currentTag,
                        orderType: this.currentTab,
                        current: this.currentPage,
                        size: this.currentSize,
                        keyword: this.keyword
                    }
                }
            )
            .then(response=> {
                if(response.data.code == 0){
                    this.proList = response.data.data.records
                    if(this.proList.length == 0){
                        this.currentPage -- 
                    }
                    for(let i = 0; i < this.proList.length; i ++){
                        let height = 0;
                        height = this.getHeight(i)
                        let minIndex = this.getIndexMAx(this.heightObj)
                        if(minIndex == 0){
                            this.dataList1.push(this.proList[i])
                            this.heightObj[0] += (210 + Number(height))
                        }else if(minIndex == 1){
                            this.dataList2.push(this.proList[i])
                            this.heightObj[1] += (210 + Number(height))
                        }else if(minIndex == 2){
                            this.dataList3.push(this.proList[i])
                            this.heightObj[2] += (210 + Number(height))
                        }else if(minIndex == 3){
                            this.dataList4.push(this.proList[i])
                            this.heightObj[3] += (210 + Number(height))
                        }else if(minIndex == 4){
                            this.dataList5.push(this.proList[i])
                            this.heightObj[4] += (210 + Number(height))
                        }
                    }
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        copyPro(id){
            this.axios.post('/api/project/copy', {
                id: id,
            })
            .then(response=> {
                if(response.data.code == 0){
                   this.ifShowTip = true
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        getBLen(str) {  
            var len = 0;  
            for (var i=0; i<str.length; i++) {   
                var c = str.charCodeAt(i);   
                //单字节加1   
                if ((c >= 0x0001 && c <= 0x007e) || (0xff60<=c && c<=0xff9f)) {   
                    len++;   
                }   
                else {   
                    len+=2;   
                }   
            }   
            return Math.ceil(len/36);  
        },  
        getNameLen(str) {  
            var len = 0;  
            for (var i=0; i<str.length; i++) {   
                var c = str.charCodeAt(i);   
                //单字节加1   
                if ((c >= 0x0001 && c <= 0x007e) || (0xff60<=c && c<=0xff9f)) {   
                    len++;   
                }   
                else {   
                    len+=2;   
                }   
            }   
            return Math.ceil(len/22) - 1;  
        },  
        getHeight(i) {
            let length1 = this.proList[i]['description']==undefined?0:this.getBLen(this.proList[i]['description'])
            let length2 = this.proList[i]['openingWords']==undefined?0:this.getBLen(this.proList[i]['openingWords'])
            let length3 = this.proList[i]['name']==undefined?0:this.getNameLen(this.proList[i]['name'])
            let height = 0
            height = (length1 + length2)*21 + length3*22
            return height
        },
        getIndexMAx (arr){
            const minNum = Math.min(...arr)
            const minIndex = arr.indexOf(minNum)
            return minIndex
        },
        queryPic() {
            this.axios.get('/api/public/course/list')
            .then(response=> {
                if(response.data.code == 0){
                    this.picList = response.data.data
                    for(let i = 0; i < this.picList.length; i+=5){
                        this.picData.push(this.picList.slice(i,i+5))
                    }
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        enterSearchMember() {
            this.currentPage = 1
            this.proList = []
            this.dataList1 = []
            this.dataList2 = []
            this.dataList3 = []
            this.dataList4 = []
            this.dataList5 = []
            this.queryData()
        },
        experiencePro(item) {
            let routeData = this.$router.resolve({path: '/Chat',query:{projectId:item.id,projectName:item.name,des:item.description}});
            window.open(routeData.href, '_blank');
        },
        goTaskList() {
            this.$router.push("/MyProject")
        },
        jumpToLink(url) {
            window.open(url, '_blank');
        },
        nameReplace(name) {
            if(name.length > 0){
                let name1 = name.substring(0,1)
                let name2 = ''
                for(let i = 0; i < name.length - 1; i++){
                    name2 += ' *'
                }
                return name1 + name2
            }else{  
                return ''
            }
        }
    },
    mounted: function() {
        this.sessionData('set','currentMenu','ScriptSquare');
        window.addEventListener("scroll", this.handleScroll, true); 
        this.querySence()
        this.queryData()
        this.queryPic()
    },
    destroyed(){
        window.removeEventListener('scroll', this.handleScroll, true);
    },
}
</script>
<style scoped  lang="less">
    .slick-slide {
        text-align: center;
        height: 160px;
        line-height: 160px;
        background: #364d79;
        overflow: hidden;
    }
    .custom-slick-arrow {
        width: 25px;
        height: 25px;
        font-size: 25px;
        color: rgba(204, 204, 204, 1);
        background-color: rgba(31, 45, 61, 0.11);
        opacity: 0.3;
    }
    .custom-slick-arrow:hover {
        opacity: 1;
        color: rgba(204, 204, 204, 1);
    }
    .slick-slide h3 {
        color: rgba(204, 204, 204, 1);
    }
    .custom-slick-arrow:before {
        display: none;
    }
    .script-square{
        overflow-y: auto;
        height: 100%;
        display: flex;
        flex-direction: column;
        background: #f0f2f3;
        .head{
            position: relative;
            width: 100%;
            height: 193px;
            img{
                width: 100%;
                height: 100%;
            }
            input:focus{ 
                outline: none; 
            }
        }
        .tutorials{
            padding-bottom: 23px;
            background: #fff;
            img{
                width: 220px;
                margin-right: 25px;
                height: 120px;
            }
            img:nth-last-child(1){
                margin-right: 0px;
            }
            .carousel-pic img{
                float: left;
                cursor: pointer;
            }
        }
        .content{
            background: rgba(240, 242, 243, 1);
            padding-top: 22px;
            padding-bottom: 55px;
            flex: 1;
            .left-menu{
                width: 168px;
                border-right: none;
                div{
                    color: rgba(80, 80, 80, 1);
                    line-height: 32px;
                    cursor: pointer;
                    i{
                        font-size: 14px;
                    }
                    span{
                        font-size: 12px;
                        margin-left: 9px;
                    }
                }
                div.active{
                    color: rgba(34, 215, 187, 1);
                }
            }
            .right-content{
                flex: 1;
                .tag-list{
                    border-bottom: 1px solid rgba(221, 221, 221, 1);
                    padding-bottom: 16px;
                    span{
                        color: rgba(80, 80, 80, 1);
                        font-size: 13px;
                        margin-right: 28px;
                        cursor: pointer;
                    }
                    span.active{
                        color: rgba(34, 215, 187, 1);
                    }
                }
                .choose-type{
                    padding-top: 16px;
                    span{
                        color: rgba(153, 153, 153, 1);
                        font-size: 13px;
                        padding-right: 36px;
                        cursor: pointer;
                    }
                    span.active{
                        color: rgba(34, 215, 187, 1);
                    }
                }
                .project-list{
                    margin-top: 16px;
                    .col{
                        float: left;
                        width: 192px;
                        margin-right: 18px;
                        display: inline-block;
                        border-radius: 4px;
                        overflow: hidden;
                        .list{
                            background: #fff;
                            margin-bottom: 18px;
                            .box1{
                                position: relative;
                                padding: 12px 8px 0px 8px;
                                .mask{
                                    width: 100%;
                                    height: 100%;
                                    background: rgba(0, 0, 0, 0.3);
                                    position: absolute;
                                    left: 0px;
                                    top: 0px;
                                    display: none;
                                    div{
                                        width:160px;
                                        height:32px;
                                        margin:12px auto;
                                        color:#fff;
                                        text-align:center;
                                        font-size:14px;
                                        line-height:32px;
                                        border-radius:4px;
                                        cursor:pointer;
                                    }
                                    div:nth-child(1){
                                        background:rgba(34, 215, 187, 1);
                                    }
                                    div:nth-child(2){
                                        background:rgba(53, 82, 255, 1);
                                    }
                                }
                                .generalization{
                                    margin-bottom: 12px;
                                    clear: both;
                                    float: left;
                                    .item{
                                        display: inline-block;
                                        width: 38px;
                                        height: 34px;
                                        font-size: 12px;
                                        border-radius: 2px;
                                        padding: 1px;
                                        box-sizing: border-box;
                                        margin-right: 8px;
                                        float: left;
                                        .item-content{
                                            letter-spacing:-1px;
                                            img{
                                                width: 11px;
                                                margin-right: 0px;
                                            }
                                        }
                                        .num{
                                            text-align:center;
                                            line-height: 10px;
                                        }
                                    }
                                    .item:nth-child(1){
                                        color: rgba(34, 215, 187, 1);
                                        border: 1px solid rgba(34, 215, 187, 1);
                                    }
                                    .item:nth-child(2){
                                        color: rgba(24, 144, 255, 1);
                                        border: 1px solid rgba(24, 144, 255, 0.5);
                                    }
                                    .item:nth-child(3){
                                        color: rgba(172, 51, 193, 1);
                                        border: 1px solid rgba(172, 51, 193, 0.5);
                                    }
                                    .item:nth-child(4){
                                        margin-right: 0px;
                                        color: rgba(255, 141, 26, 1);
                                        border: 1px solid rgba(255, 141, 26, 0.5);
                                    }
                                }
                                .title{
                                    color: rgba(16, 16, 16, 1);
                                    font-size: 12px;
                                    margin-bottom: 2px;;
                                }
                                .des{
                                    color: rgba(153, 153, 153, 1);
                                    font-size:12px;
                                    margin-bottom: 6px;
                                }
                                .time{
                                    color: rgba(153, 153, 153, 1);
                                }
                            }
                            .box2{
                                padding: 0px 8px 10px 8px;
                            }
                            .box1:hover{
                                .mask{
                                    display: block;
                                }
                            }
                            .title2{
                                color: rgba(51, 51, 51, 1);
                                font-size: 15px;
                                font-weight: bold;
                                margin-bottom: 6px;
                            }
                            .status{
                                img{
                                    width: 12px;
                                    margin-right: 2px;
                                }
                                span{
                                    color: rgba(153, 153, 153, 1);
                                    font-size: 12px;
                                    margin-right: 16px;
                                }
                            }
                            .foot{
                                margin-top: 5px;
                                img{
                                    width: 24px;
                                    float: left;
                                    border-radius: 12px;
                                }
                                span{
                                    color: rgba(80, 80, 80, 1);
                                    font-size: 14px;
                                    margin-left: 8px;
                                }
                            }
                        }
                    }
                    .col:nth-child(5){
                        margin-right: 0px;
                    }
                }
            }
        }
    }
    .place1{
        position: fixed;
        top: 48px;
        background: #f0f2f3;
        z-index: 100;
        height: 100%;
    }
    .place2{
        position: fixed;
        top: 48px;
        padding-top:10px;
        background: #f0f2f3;
        z-index: 100;
        padding-left: 168px;
        width: 100%;
        z-index: 50;
        padding-bottom: 10px;
    }
    .place3{
        padding-left: 168px;
    }
</style>
